import { Degree } from "@/types/member";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export type DegreeFields = {
  level: "HighSchool" | "Bachelors" | "Masters" | "PhD";
  institutions?: {
    id: string;
    name_en: string;
    type: string;
    country_code: string;
  } | null;
  institution_other_name?: string | null;
};

export const findInstitutionByLevel = (
  level: "HighSchool" | "Bachelors" | "Masters" | "PhD",
  degrees: DegreeFields[]
) => {
  const degree = degrees?.find((d) => d.level === level);
  return degree?.institutions?.name_en || degree?.institution_other_name || "";
};

export function getInstitutionBasedOnTier(
  tier: string,
  degrees: DegreeFields[]
): string {
  switch (tier) {
    case "Group 1": {
      return findInstitutionByLevel("HighSchool", degrees);
    }
    case "Group 2": {
      return findInstitutionByLevel("Bachelors", degrees);
    }
    case "Group 3": {
      return findInstitutionByLevel("Masters", degrees);
    }
    case "Group 4": {
      return findInstitutionByLevel("PhD", degrees);
    }
    default: {
      // Default to the last degree's institution if tier logic doesn't apply or fails
      const lastDegree = degrees[degrees.length - 1];
      return lastDegree?.institutions?.name_en || "N/A";
    }
  }
}
